// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pqDZ","buttons":"styles_buttons__2KnV4"};